import React from "react";
import { modalBoxStyle } from "../styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const OrderToParNoValidOrdersModal = ({
  isOpen,
  closeModal,
  orderToParData,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        <Grid
          container
          direction="column"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item>
              <Typography variant="h2">No Orders Created</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={closeModal}>
                <CloseOutlinedIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              width: "100%",
              marginTop: 4,
            }}
          >
            {" "}
            <Typography variant="body1">
              It looks like we were unable to find any records that were both
              under par and contained the necessary information to create an
              order.
            </Typography>
          </Box>
          
          {orderToParData?.recordsMissingInfo?.length > 0 ? (
            <>
            <br/>
            <Typography variant="body1">
              We found {orderToParData.recordsMissingInfo?.length} records
              that were missing product or vendor information that prevent us
              from automatically adding them to your order. Ensure products and
              their formats contain the necessary sizing and purchase unit data
              to enable automatically adding them to a order.
            </Typography>
            </>
          ) : (
            <></>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              sx={{
                width: "50%",
                height: "40px",
                marginLeft: 1,
              }}
              onClick={closeModal}
            >
              <Typography variant="largeButton">Ok</Typography>
            </Button>
          </Box>
        </Grid>
      </Box>
    </Modal>
  );
};

export default OrderToParNoValidOrdersModal;
